<cv-current-agent-states-pm
    [moduleManager]="moduleManager"
    [moduleKey]="moduleKey"
></cv-current-agent-states-pm>